import { render } from "./Partners.vue?vue&type=template&id=268348db"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__